module.exports = __webpack_public_path__ + "img/About.a15b244d.png";